module.exports = __webpack_public_path__ + "img/scop6.5e21b779.jpg";